import styled, { css } from "../../styled/index";
import darken from "polished/lib/color/darken";
import { Loader } from "./loader";
import { CS } from "../../styles/index";
const MainClickable = css `
  transition: 0.3s all;
  cursor: pointer;
  &:hover {
    background: ${darken(0.03, "white")};
    ${CS.shadow.light.one};
  }
`;
export const BoxList = styled("div") `
  > * {
    border-bottom: none !important;
    &:last-child {
      border-bottom: 1px solid ${(props) => props.theme.box.border} !important;
    }
  }
`;
export const Box = styled("div") `
  position: relative;
  background: ${(props) => props.theme.box.background};
  color: ${(props) => props.theme.box.text};
  border: 1px solid ${(props) => props.theme.box.border};
  border-radius: 3px;
  ${(props) => props.shadow ? CS.shadow.light[props.shadow] : ""};
  ${(props) => !props.clickable ? "" : MainClickable};
`;
export const BoxSection = styled("div") `
  padding: ${(props) => typeof props.paddingtb === "number" ? props.paddingtb : 20}px ${(props) => typeof props.paddinglr === "number" ? props.paddinglr : 20}px;
  border-bottom: 1px solid ${(props) => props.theme.box.border};
  &:last-child {
    border-bottom: none;
  }
  ${({ border, theme }) => border ? css `
    border: 1px solid ${theme.box.border};
    &:last-child {
      border-bottom: 1px solid ${theme.box.border};
    } 
  ` : ""};
`;
export const BoxHeading = styled("div") `
  padding: 15px 20px;
  border-bottom: 1px solid ${(props) => props.theme.box.border};
  &:last-child { 
    border-bottom: none;
  }
`;
export const BoxLoader = Loader;
//# sourceMappingURL=index.js.map